import { forwardRef } from 'react';
import type { InputHTMLAttributes, SelectHTMLAttributes, TextareaHTMLAttributes } from 'react';

export function Field({ label, help, error, children }: { label: string; help?: string; error?: string; children: React.ReactNode }) {
  return (
    <label className="block">
      <span className="mb-1 block text-sm font-medium text-clinical-ink">{label}</span>
      {children}
      {help ? <span className="mt-1 block text-xs leading-5 text-clinical-muted">{help}</span> : null}
      {error ? <span className="mt-1 block text-xs text-clinical-danger">{error}</span> : null}
    </label>
  );
}

const control =
  'focus-ring min-h-11 w-full rounded-lg border border-clinical-line bg-clinical-card px-3 py-2 text-base text-clinical-ink shadow-sm placeholder:text-clinical-muted/70';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(function Input({ className = '', ...props }, ref) {
  return <input ref={ref} className={`${control} ${className}`} {...props} />;
});

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(function Select({ className = '', ...props }, ref) {
  return <select ref={ref} className={`${control} ${className}`} {...props} />;
});

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(function Textarea(
  { className = '', ...props },
  ref
) {
  return <textarea ref={ref} className={`${control} min-h-24 ${className}`} {...props} />;
});
